export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const SWITCH_ORGANIZATION = "switchOrganization";
export const SET_ERRORS = "errors";
export const BRANDING = "branding";
